(function () {
  'use strict';

  function initFaq(root) {
    if (!root || root.dataset.faqReady === 'true') return;
    root.dataset.faqReady = 'true';

    var form = root.querySelector('[data-faq-search-form]');
    var input = root.querySelector('[data-faq-search]');
    var heading = root.querySelector('[data-faq-heading]');
    var list = root.querySelector('[data-faq-list]');
    var empty = root.querySelector('[data-faq-empty]');
    var announcement = root.querySelector('[data-faq-announcement]');
    var topics = Array.prototype.slice.call(root.querySelectorAll('[data-faq-topic]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
    var activeTopic = '';

    function normalize(value) {
      return String(value || '').toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    }

    function closeAll(except) {
      items.forEach(function (item) {
        if (item !== except) item.open = false;
      });
    }

    items.forEach(function (item) {
      var summary = item.querySelector('summary');
      if (summary) summary.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          item.open = !item.open;
        } else if (event.key === 'Escape' && item.open) {
          event.preventDefault();
          item.open = false;
        }
      });
      item.addEventListener('toggle', function () {
        if (item.open) closeAll(item);
      });
    });

    function sortNumber(item, name) {
      return parseInt(item.dataset[name] || '999', 10);
    }

    function updateTopicState() {
      topics.forEach(function (button) {
        var selected = button.dataset.faqTopic === activeTopic;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    function announce(count) {
      if (!announcement) return;
      var template = count === 1 ? root.dataset.countOne : root.dataset.countOther;
      announcement.textContent = template.replace('{{ count }}', String(count));
    }

    function render() {
      var query = normalize(input && input.value);
      var visible;

      if (query) {
        visible = items.filter(function (item) { return normalize(item.textContent).indexOf(query) !== -1; });
        heading.textContent = root.dataset.headingSearch;
        visible.sort(function (a, b) { return items.indexOf(a) - items.indexOf(b); });
      } else if (activeTopic) {
        visible = items.filter(function (item) { return item.dataset.category === activeTopic; });
        var activeButton = topics.filter(function (button) { return button.dataset.faqTopic === activeTopic; })[0];
        heading.textContent = activeButton ? activeButton.textContent.trim() : root.dataset.headingDefault;
        visible.sort(function (a, b) { return sortNumber(a, 'categoryIndex') - sortNumber(b, 'categoryIndex'); });
      } else {
        visible = items.filter(function (item) { return sortNumber(item, 'mostAskedIndex') < 999; });
        heading.textContent = root.dataset.headingDefault;
        visible.sort(function (a, b) { return sortNumber(a, 'mostAskedIndex') - sortNumber(b, 'mostAskedIndex'); });
      }

      closeAll();
      items.forEach(function (item) { item.hidden = true; });
      visible.forEach(function (item) {
        list.appendChild(item);
        item.hidden = false;
      });

      if (visible.length) visible[0].open = true;
      empty.hidden = visible.length !== 0;
      announce(visible.length);
      updateTopicState();
    }

    topics.forEach(function (button, index) {
      button.addEventListener('click', function () {
        var topic = button.dataset.faqTopic;
        activeTopic = activeTopic === topic ? '' : topic;
        if (input) input.value = '';
        render();
      });
      button.addEventListener('keydown', function (event) {
        var nextIndex;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          button.click();
          return;
        }
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % topics.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + topics.length) % topics.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = topics.length - 1;
        if (typeof nextIndex === 'number') {
          event.preventDefault();
          topics[nextIndex].focus();
        }
      });
    });

    if (input) input.addEventListener('input', render);
    if (form) form.addEventListener('submit', function (event) {
      event.preventDefault();
      render();
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
      heading.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });

    render();
  }

  function boot() {
    var root = document.querySelector('[data-faq-redesign]');
    if (root) initFaq(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
